export const CUSTOMER_REASONS = {
    UNCERTAIN: { reasonId: 1, reasonName: 'Uncertain' },
    STANDARD: { reasonId: 2, reasonName: 'Standard' },
    CREDIT_CARD: { reasonId: 3, reasonName: 'Credit Card' },
    CONSUMABLES: { reasonId: 4, reasonName: 'Consumables' },
    VSP: { reasonId: 5, reasonName: 'VSP' },
    CONSIGNMENT: { reasonId: 6, reasonName: 'Consignment' },
    OTHER: { reasonId: 8, reasonName: 'Other' },
    STOCK_TRANSFER: { reasonId: 10, reasonName: 'Stock Transfer' },
    FACTORY_RETURN: { reasonId: 11, reasonName: 'Factory Return' },
    KIT_ACCOUNT: { reasonId: 12, reasonName: 'Kit Account' },
    FREIGHT_CLAIM: { reasonId: 13, reasonName: 'Freight Claim' },
}

export const CUSTOMER_TYPES = {
    OEM: {
        typeId: 8,
        title: 'Designs and builds original equipment and owns the material specification.  Products purchased from AWC are incorporated into the OEM\'s product.',
        typeText: 'Original Equipment Manufacturer (OEM)',
    },
    SYSTEMS_INTEGRATOR: {
        typeId: 9,
        title: 'Designs and builds original equipment with limited material specification responsibilities.',
        typeText: 'System Integrator/Fabricator',
    },
    END_USER: {
        typeId: 10,
        title: 'The term end user is usually associated with a chemical plant, refinery, etc. where the customer that you are selling and/or quoting to is the person that will be consuming the material directly. OEMs that purchase from AWC but do not incorporate products purchased from AWC into its products should be classified as End Users.',
        typeText: 'End User',
    },
    DOMESTIC_RESELLER: {
        typeId: 11,
        title: 'Buys and resells within the United States.',
        typeText: 'Domestic Reseller',
    },
    EXPORT_RESELLER: {
        typeId: 12,
        title: 'Buys and resells - exports outside of the United States.',
        typeText: 'Export Reseller',
    },
    CONTRACTOR: {
        typeId: 13,
        title: 'Designs and specifies for End Users. Can also have actual construction and procurement responsibilities as well.',
        typeText: 'Engineering Contractor',
    },
    INTEGRATED_SUPPLIER: {
        typeId: 14,
        title: 'Contract buyer for End User or OEM.',
        typeText: 'Integrated Supplier',
    },
    INSTALLATION_CONTRACTOR: {
        typeId: 15,
        title: 'Electrical, Instrumentation or Mechanical Contractor responsible for installation of our products at End User facilities. (Not a systems integrator).',
        typeText: 'Installation Contractor',
    },
    UNCERTAIN: {
        typeId: 16,
        title: 'No specific definition, but includes Miscellaneous Cash Sale accounts and customers not classified elsewhere.',
        typeText: 'Uncertain',
    },
}

export const STATE_CODES = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District Of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
}

export const COUNTRY_CODES: Record<string, string> = {
    AF: 'Afghanistan',
    AX: 'Aland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic of the Congo',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: 'Cote D\'Ivoire',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curacao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and Mcdonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: 'Korea, Democratic People\'s Republic of',
    KR: 'Korea, Republic of',
    XK: 'Kosovo',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Lao People\'s Democratic Republic',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyan Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia, the Former Yugoslav Republic of',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States of',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    AN: 'Netherlands Antilles',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territory, Occupied',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthelemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    CS: 'Serbia and Montenegro',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan, Province of China',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Viet Nam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.s.',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
}

export const COUNTRY_TABLE = [
    {
        Code: 'AD',
        Name: 'ANDORRA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AE',
        Name: 'UNITED ARAB EMIRATES',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AF',
        Name: 'AFGHANISTAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AG',
        Name: 'ANTIGUA AND BARBUDA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AI',
        Name: 'ANGUILLA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AL',
        Name: 'ALBANIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AM',
        Name: 'ARMENIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AN',
        Name: 'NETHERLANDS ANTILLES',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AO',
        Name: 'ANGOLA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AQ',
        Name: 'ANTARCTICA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AR',
        Name: 'ARGENTINA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AS',
        Name: 'AMERICAN SAMOA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AT',
        Name: 'AUSTRIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AU',
        Name: 'AUSTRALIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AW',
        Name: 'ARUBA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'AZ',
        Name: 'AZERBAIJAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BA',
        Name: 'BOSNIA AND HERZEGOVINA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BB',
        Name: 'BARBADOS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BD',
        Name: 'BANGLADESH',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BE',
        Name: 'BELGIUM',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BF',
        Name: 'BURKINA FASO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BG',
        Name: 'BULGARIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BH',
        Name: 'BAHRAIN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BI',
        Name: 'BURUNDI',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BJ',
        Name: 'BENIN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BM',
        Name: 'BERMUDA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BN',
        Name: 'BRUNEI DARUSSALAM',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BO',
        Name: 'BOLIVIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BR',
        Name: 'BRAZIL',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BS',
        Name: 'BAHAMAS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BT',
        Name: 'BHUTAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BV',
        Name: 'BOUVET ISLAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BW',
        Name: 'BOTSWANA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BY',
        Name: 'BELARUS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'BZ',
        Name: 'BELIZE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CA',
        Name: 'CANADA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CC',
        Name: 'COCOS (KEELING) ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CD',
        Name: 'CONGO, THE DEMOCRATIC REPUBLIC OF THE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CF',
        Name: 'CENTRAL AFRICAN REPUBLIC',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CG',
        Name: 'CONGO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CH',
        Name: 'SWITZERLAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CI',
        Name: 'COTE D\'IVOIRE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CK',
        Name: 'COOK ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CL',
        Name: 'CHILE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CM',
        Name: 'CAMEROON',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CN',
        Name: 'CHINA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CO',
        Name: 'COLOMBIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CR',
        Name: 'COSTA RICA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CV',
        Name: 'CAPE VERDE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CX',
        Name: 'CHRISTMAS ISLAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CY',
        Name: 'CYPRUS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'CZ',
        Name: 'CZECH REPUBLIC',
        ISO: 'ISO 3166',
    },
    {
        Code: 'DE',
        Name: 'GERMANY',
        ISO: 'ISO 3166',
    },
    {
        Code: 'DJ',
        Name: 'DJIBOUTI',
        ISO: 'ISO 3166',
    },
    {
        Code: 'DK',
        Name: 'DENMARK',
        ISO: 'ISO 3166',
    },
    {
        Code: 'DM',
        Name: 'DOMINICA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'DO',
        Name: 'DOMINICAN REPUBLIC',
        ISO: 'ISO 3166',
    },
    {
        Code: 'DZ',
        Name: 'ALGERIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'EC',
        Name: 'ECUADOR',
        ISO: 'ISO 3166',
    },
    {
        Code: 'EE',
        Name: 'ESTONIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'EG',
        Name: 'EGYPT',
        ISO: 'ISO 3166',
    },
    {
        Code: 'EH',
        Name: 'WESTERN SAHARA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ER',
        Name: 'ERITREA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ES',
        Name: 'SPAIN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ET',
        Name: 'ETHIOPIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'FI',
        Name: 'FINLAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'FJ',
        Name: 'FIJI',
        ISO: 'ISO 3166',
    },
    {
        Code: 'FK',
        Name: 'FALKLAND ISLANDS (MALVINAS)',
        ISO: 'ISO 3166',
    },
    {
        Code: 'FM',
        Name: 'MICRONESIA, FEDERATED STATES OF',
        ISO: 'ISO 3166',
    },
    {
        Code: 'FO',
        Name: 'FAROE ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'FR',
        Name: 'FRANCE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GA',
        Name: 'GABON',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GB',
        Name: 'UNITED KINGDOM',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GD',
        Name: 'GRENADA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GE',
        Name: 'GEORGIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GF',
        Name: 'FRENCH GUIANA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GH',
        Name: 'GHANA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GI',
        Name: 'GIBRALTAR',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GL',
        Name: 'GREENLAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GM',
        Name: 'GAMBIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GN',
        Name: 'GUINEA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GP',
        Name: 'GUADELOUPE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GQ',
        Name: 'EQUATORIAL GUINEA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GR',
        Name: 'GREECE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GS',
        Name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GT',
        Name: 'GUATEMALA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GU',
        Name: 'GUAM',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GW',
        Name: 'GUINEA-BISSAU',
        ISO: 'ISO 3166',
    },
    {
        Code: 'GY',
        Name: 'GUYANA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'HK',
        Name: 'HONG KONG',
        ISO: 'ISO 3166',
    },
    {
        Code: 'HM',
        Name: 'HEARD ISLAND AND MCDONALD ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'HN',
        Name: 'HONDURAS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'HR',
        Name: 'CROATIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'HT',
        Name: 'HAITI',
        ISO: 'ISO 3166',
    },
    {
        Code: 'HU',
        Name: 'HUNGARY',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ID',
        Name: 'INDONESIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'IE',
        Name: 'IRELAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'IL',
        Name: 'ISRAEL',
        ISO: 'ISO 3166',
    },
    {
        Code: 'IN',
        Name: 'INDIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'IO',
        Name: 'BRITISH INDIAN OCEAN TERRITORY',
        ISO: 'ISO 3166',
    },
    {
        Code: 'IQ',
        Name: 'IRAQ',
        ISO: 'ISO 3166',
    },
    {
        Code: 'IS',
        Name: 'ICELAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'IT',
        Name: 'ITALY',
        ISO: 'ISO 3166',
    },
    {
        Code: 'JM',
        Name: 'JAMAICA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'JO',
        Name: 'JORDAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'JP',
        Name: 'JAPAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KE',
        Name: 'KENYA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KG',
        Name: 'KYRGYZSTAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KH',
        Name: 'CAMBODIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KI',
        Name: 'KIRIBATI',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KM',
        Name: 'COMOROS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KN',
        Name: 'SAINT KITTS AND NEVIS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KR',
        Name: 'KOREA, REPUBLIC OF',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KW',
        Name: 'KUWAIT',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KY',
        Name: 'CAYMAN ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'KZ',
        Name: 'KAZAKSTAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LA',
        Name: 'LAO PEOPLE\'S DEMOCRATIC REPUBLIC',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LB',
        Name: 'LEBANON',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LC',
        Name: 'SAINT LUCIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LI',
        Name: 'LIECHTENSTEIN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LK',
        Name: 'SRI LANKA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LR',
        Name: 'LIBERIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LS',
        Name: 'LESOTHO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LT',
        Name: 'LITHUANIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LU',
        Name: 'LUXEMBOURG',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LV',
        Name: 'LATVIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'LY',
        Name: 'LIBYAN ARAB JAMAHIRIYA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MA',
        Name: 'MOROCCO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MC',
        Name: 'MONACO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MD',
        Name: 'MOLDOVA, REPUBLIC OF',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MG',
        Name: 'MADAGASCAR',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MH',
        Name: 'MARSHALL ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MK',
        Name: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ML',
        Name: 'MALI',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MM',
        Name: 'MYANMAR',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MN',
        Name: 'MONGOLIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MO',
        Name: 'MACAU',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MP',
        Name: 'NORTHERN MARIANA ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MQ',
        Name: 'MARTINIQUE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MR',
        Name: 'MAURITANIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MS',
        Name: 'MONTSERRAT',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MT',
        Name: 'MALTA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MU',
        Name: 'MAURITIUS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MV',
        Name: 'MALDIVES',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MW',
        Name: 'MALAWI',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MX',
        Name: 'MEXICO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MY',
        Name: 'MALAYSIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'MZ',
        Name: 'MOZAMBIQUE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NA',
        Name: 'NAMIBIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NC',
        Name: 'NEW CALEDONIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NE',
        Name: 'NIGER',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NF',
        Name: 'NORFOLK ISLAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NG',
        Name: 'NIGERIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NI',
        Name: 'NICARAGUA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NL',
        Name: 'NETHERLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NO',
        Name: 'NORWAY',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NP',
        Name: 'NEPAL',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NR',
        Name: 'NAURU',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NU',
        Name: 'NIUE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'NZ',
        Name: 'NEW ZEALAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'OM',
        Name: 'OMAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PA',
        Name: 'PANAMA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PE',
        Name: 'PERU',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PF',
        Name: 'FRENCH POLYNESIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PG',
        Name: 'PAPUA NEW GUINEA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PH',
        Name: 'PHILIPPINES',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PK',
        Name: 'PAKISTAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PL',
        Name: 'POLAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PM',
        Name: 'SAINT PIERRE AND MIQUELON',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PN',
        Name: 'PITCAIRN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PR',
        Name: 'PUERTO RICO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PS',
        Name: 'PALESTINIAN TERRITORY, OCCUPIED',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PT',
        Name: 'PORTUGAL',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PW',
        Name: 'PALAU',
        ISO: 'ISO 3166',
    },
    {
        Code: 'PY',
        Name: 'PARAGUAY',
        ISO: 'ISO 3166',
    },
    {
        Code: 'QA',
        Name: 'QATAR',
        ISO: 'ISO 3166',
    },
    {
        Code: 'RE',
        Name: 'REUNION',
        ISO: 'ISO 3166',
    },
    {
        Code: 'RO',
        Name: 'ROMANIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'RU',
        Name: 'RUSSIAN FEDERATION',
        ISO: 'ISO 3166',
    },
    {
        Code: 'RW',
        Name: 'RWANDA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SA',
        Name: 'SAUDI ARABIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SB',
        Name: 'SOLOMON ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SC',
        Name: 'SEYCHELLES',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SE',
        Name: 'SWEDEN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SG',
        Name: 'SINGAPORE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SH',
        Name: 'SAINT HELENA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SI',
        Name: 'SLOVENIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SJ',
        Name: 'SVALBARD AND JAN MAYEN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SK',
        Name: 'SLOVAKIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SL',
        Name: 'SIERRA LEONE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SM',
        Name: 'SAN MARINO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SN',
        Name: 'SENEGAL',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SO',
        Name: 'SOMALIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SR',
        Name: 'SURINAME',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ST',
        Name: 'SAO TOME AND PRINCIPE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SV',
        Name: 'EL SALVADOR',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SY',
        Name: 'SYRIAN ARAB REPUBLIC',
        ISO: 'ISO 3166',
    },
    {
        Code: 'SZ',
        Name: 'SWAZILAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TC',
        Name: 'TURKS AND CAICOS ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TD',
        Name: 'CHAD',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TF',
        Name: 'FRENCH SOUTHERN TERRITORIES',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TG',
        Name: 'TOGO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TH',
        Name: 'THAILAND',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TJ',
        Name: 'TAJIKISTAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TK',
        Name: 'TOKELAU',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TM',
        Name: 'TURKMENISTAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TN',
        Name: 'TUNISIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TO',
        Name: 'TONGA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TP',
        Name: 'EAST TIMOR',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TR',
        Name: 'TURKEY',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TT',
        Name: 'TRINIDAD AND TOBAGO',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TV',
        Name: 'TUVALU',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TW',
        Name: 'TAIWAN, PROVINCE OF CHINA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'TZ',
        Name: 'TANZANIA, UNITED REPUBLIC OF',
        ISO: 'ISO 3166',
    },
    {
        Code: 'UA',
        Name: 'UKRAINE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'UG',
        Name: 'UGANDA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'UM',
        Name: 'UNITED STATES MINOR OUTLYING ISLANDS',
        ISO: 'ISO 3166',
    },
    {
        Code: 'US',
        Name: 'UNITED STATES',
        ISO: 'ISO 3166',
    },
    {
        Code: 'UY',
        Name: 'URUGUAY',
        ISO: 'ISO 3166',
    },
    {
        Code: 'UZ',
        Name: 'UZBEKISTAN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'VA',
        Name: 'HOLY SEE (VATICAN CITY STATE)',
        ISO: 'ISO 3166',
    },
    {
        Code: 'VC',
        Name: 'SAINT VINCENT AND THE GRENADINES',
        ISO: 'ISO 3166',
    },
    {
        Code: 'VE',
        Name: 'VENEZUELA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'VG',
        Name: 'VIRGIN ISLANDS, BRITISH',
        ISO: 'ISO 3166',
    },
    {
        Code: 'VI',
        Name: 'VIRGIN ISLANDS, U.S.',
        ISO: 'ISO 3166',
    },
    {
        Code: 'VN',
        Name: 'VIET NAM',
        ISO: 'ISO 3166',
    },
    {
        Code: 'VU',
        Name: 'VANUATU',
        ISO: 'ISO 3166',
    },
    {
        Code: 'WF',
        Name: 'WALLIS AND FUTUNA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'WS',
        Name: 'SAMOA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'YE',
        Name: 'YEMEN',
        ISO: 'ISO 3166',
    },
    {
        Code: 'YT',
        Name: 'MAYOTTE',
        ISO: 'ISO 3166',
    },
    {
        Code: 'YU',
        Name: 'YUGOSLAVIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ZA',
        Name: 'SOUTH AFRICA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ZM',
        Name: 'ZAMBIA',
        ISO: 'ISO 3166',
    },
    {
        Code: 'ZW',
        Name: 'ZIMBABWE',
        ISO: 'ISO 3166',
    },
]

// color string api sends with credit info
export enum COLORS {
    RED = 'red',
    YELLOW = 'yellow',
    GREEN = 'green',
    GREY = 'grey',
}
